var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('px-lista-selecao-requisicao-produtos',{model:{value:(_vm.produtos),callback:function ($$v) {_vm.produtos=$$v},expression:"produtos"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }